export default __webpack_public_path__ + "static/media/HerTech_logo_.7c553a23.png";